module.exports = __webpack_public_path__ + "img/unionpay.8ed3019d.png";